import { useCallback } from 'react';

import { CloseLine, Menu2Line } from 'components/icons/System';

import IconButton from './IconButton';

const HeaderMenuToggle = ({
  setIsMenuOpen,
  isMenuOpen,
}: {
  setIsMenuOpen: (value: boolean) => void;
  isMenuOpen: boolean;
}) => {
  const handleMenuOpen = useCallback(() => {
    setIsMenuOpen(!isMenuOpen);
  }, [isMenuOpen]);

  return (
    <IconButton
      className="ml-[-12px] hover:bg-current px-0"
      icon={isMenuOpen ? CloseLine : Menu2Line}
      isDark={!isMenuOpen}
      aria-label="Toggle menu"
      data-testid="menu-toggle"
      onClick={handleMenuOpen}
    />
  );
};

export default HeaderMenuToggle;
